var keyMirror = require( 'key-mirror' );

module.exports = keyMirror({

	  EDIT_ORGANISATION 				        : 	null,
  	GET_ORGANISATION 				          : 	null,
  	LOAD_ORGANISATIONS				        : 	null,
  	SET_ORGANISATION 				          : 	null,
  	SET_LOADING 					            : 	null,
  	SET_ORGANISATION_TYPE_TO_VIEW 	  : 	null,
  	LOAD_CONTRACTORS 				          : 	null,
  	STORE_CONTRACTORS 				        : 	null,
  	SET_CONTRACTOR_TO_VIEW_DATA_FOR	  : 	null,
  	LOAD_NON_APPROVED_FOR_PILE 		    : 	null,
  	STORE_UNAPPROVED_PILE 			      : 	null,
    REMOVE_FROM_PILE                  :   null,
    PROCESS_UNAPPROVED                :   null,
    SET_NO_MORE_TO_PROCESS            :   null,
    SET_PILE_CHECK_TO_LOAD_TYPE       :   null
});


// WEBPACK FOOTER //
// ./resources/assets/js/data-feed/constants/DataFeedConstants.js